let merchantLoginPort;
// sso登录端口
const hostname = window && window.location && window.location.hostname;

if(hostname === 'localhost') {
    // merchantLoginPort = 'http://127.0.0.1:8093';
    // merchantLoginPort = 'http://192.168.0.101:8093';
    merchantLoginPort = 'https://47.100.41.121';
}else if(hostname === '106.14.192.98'||hostname === '47.100.41.121'){
    merchantLoginPort = 'https://47.100.41.121';
}else {
    // merchantLoginPort = 'http://127.0.0.1:8093';
    merchantLoginPort = 'https://crm.lunchbox.asia';
    // merchantLoginPort = 'http://192.168.0.103:8093';
}

export default merchantLoginPort